import React, { useEffect } from 'react';
import styled from 'styled-components';
// custom
import { useStore } from './context/appContext';
import getPdfContract from './apis/getPdfContract';
// components
import Topbar from './components/Topbar';
import Loading from './components/Loading';
import Main from './pages/Main';
import CameraComponent from './components/CameraV2';

const MainGrid = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 0.5rem;
  grid-template-areas:
    'header'
    'content';
  justify-items: stretch;
  align-items: stretch;
  background-color: ${(p) => p.theme.background};
`;

const TopBarDiv = styled.div`
  grid-area: header;
`;

const ContentDiv = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 0.2rem;
  grid-area: content;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-row-gap: 0.5rem;
  grid-template-areas:
    'title'
    'content'
    'buttons';
  justify-items: stretch;
  align-items: stretch;
`;

function App() {
  const {
    operation,
    user,
    setContracts,
    setError,
    setLoading,
    loading,
    camera,
    step
  } = useStore();

  const handleGenerateContract = async () => {
    setLoading(true);
    await getPdfContract(user, setContracts, setError);
    setLoading(false);
  };

  useEffect(() => {
    if (operation && user.id) {
      handleGenerateContract();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operation, user.id]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : camera.open ? (
        <CameraComponent step={step} />
      ) : (
        <MainGrid>
          <TopBarDiv>{step > 3 && step < 8 && <Topbar />}</TopBarDiv>
          <ContentDiv>
            <Main />
          </ContentDiv>
        </MainGrid>
      )}
    </>
  );
}

export default App;
